import React, { useEffect, useState } from "react";
import { FaMoneyBillWave, FaCreditCard, FaCheck } from "react-icons/fa";
import "./PaymentModal.css";
import CommonButton from "../../../../components/button/CommonButton";

const PaymentModal = ({ visible, onClose, onHandleSelect, cod, online }) => {
  const [selectedPayment, setSelectedPayment] = useState(1);

  useEffect(() => {
    if (visible) {
      if (online) {
        setSelectedPayment(1);
      } else if (cod) {
        setSelectedPayment(0);
      }
    }
  }, [visible, cod, online]);

  if (!visible) return null;

  return (
    <div className="payment-modal-overlay">
      <div
        className={`payment-modal-sheet ${
          cod && online
            ? "payment-modal-sheet-large"
            : "payment-modal-sheet-small"
        }`}
      >
        <div className="payment-modal-header">
          <h3 className="payment-modal-header-text">Select Payment Method</h3>
        </div>

        <div className="payment-modal-option-container">
          {!!online && (
            <div
              className={`payment-modal-option`}
              onClick={() => setSelectedPayment(1)}
            >
              <FaCreditCard className="payment-modal-icon" />
              <span className="payment-modal-option-text">Online Payment</span>
              {selectedPayment === 1 && (
                <FaCheck className="payment-modal-check-icon" />
              )}
            </div>
          )}
          {!!cod && (
            <div
              className={`payment-modal-option`}
              onClick={() => setSelectedPayment(0)}
            >
              <FaMoneyBillWave className="payment-modal-icon" />
              <span className="payment-modal-option-text">Cash Payment</span>
              {selectedPayment === 0 && (
                <FaCheck className="payment-modal-check-icon" />
              )}
            </div>
          )}
        </div>

        <div className="payment-modal-button-container">
          <CommonButton
            outlined
            title="Cancel"
            onPress={onClose}
            customClassName="payment-modal-cancel-button"
          />
          <CommonButton
            title="Confirm"
            onPress={() => onHandleSelect(selectedPayment)}
            customClassName="payment-modal-confirm-button"
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
